import React, { useCallback, useMemo, useRef, useState } from 'react';

import { IoIosArrowDown } from 'react-icons/io';

import { Form } from '@unform/web';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { FormHandles } from '@unform/core';
import { Container, Events, Koro } from './styles';
import Select from '~/components/Select';

import Textarea from '~/components/Textarea';
import Toast from '~/utils/toast';
import getValidationErros from '~/utils/getValidationsErrors';
import Loading from '~/components/Loading';

interface IFormData {
  event: string;
  message: string;
}

const Support: React.FC = () => {
  const [activeKoro, setActiveKoro] = useState(false);
  const [activeEvents, setActiveEvents] = useState(false);
  const [eventSelected, setEventSelected] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const events = useMemo(
    () => [
      {
        id: 1,
        value: 'evento 1',
        selected: false,
      },
      {
        id: 2,
        value: 'evento 2',
        selected: false,
      },
      {
        id: 3,
        value: 'evento 3',
        selected: false,
      },
    ],
    []
  );

  const handleEventChange = useCallback((e) => {
    setEventSelected(e.value);
  }, []);

  const handleMessageChange = useCallback((e) => {
    setMessage(e.target.value);
  }, []);

  const handleSubmit = useCallback(async (data: IFormData) => {
    try {
      setLoading(true);
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        event: Yup.string().required('Escolha um evento'),
        message: Yup.string().required('descreva o problema'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });
      setLoading(false);
      Toast.fire({
        icon: 'success',
        iconColor: '#ff6900',
        title: 'Solicitação enviada!',
      });

      formRef.current?.reset();
      setEventSelected('');
    } catch (error) {
      setLoading(false);
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErros(error);
        formRef.current?.setErrors(errors);
      } else {
        Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
      }
    }
  }, []);

  return (
    <Container className="container">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="bg px-3 pt-3 mt-3">
            <button
              type="button"
              onClick={() => setActiveKoro(!activeKoro)}
              className="btn-title d-flex justify-content-between align-items-center w-100 mb-3"
            >
              Koro
              <IoIosArrowDown
                size={20}
                color="#7E7E7E"
                className={`${activeKoro ? 'rotate-arrow' : 'right-arrow'}`}
              />
            </button>
            <Koro className="" active={activeKoro}>
              <p className="mb-4">
                Teve problemas com nossa plataforma?{' '}
                <a href="mailto:suporte@koro.com.br">Clique aqui</a> para abrir
                um ticket e entraremos em contato via e-mail em breve.
              </p>
            </Koro>
          </div>
          {/* <div className="bg px-3 pt-3 mt-3">
            <button
              type="button"
              onClick={() => setActiveEvents(!activeEvents)}
              className="btn-title d-flex justify-content-between align-items-center w-100 mb-3"
            >
              Eventos
              <IoIosArrowDown
                size={20}
                color="#7E7E7E"
                className={`${activeEvents ? 'rotate-arrow' : 'right-arrow'}`}
              />
            </button>
            <Events active={activeEvents}>
              <p className="mt-3">
                Em caso de problemas com um evento, o organizador é quem irá
                resolver o problema. Passaremos sua solicitação para o
                organizador para que o problema seja resolvido rapidamente!
              </p>
              <Form ref={formRef} onSubmit={handleSubmit}>
                <Select
                  name="event"
                  placeholder="Selecione o evento"
                  onChange={handleEventChange}
                  value={eventSelected}
                  options={events}
                  className="bd-input"
                />

                <Textarea
                  className="bd-input mt-4"
                  rows={5}
                  onChange={handleMessageChange}
                  name="message"
                  placeholder="Digite sua solicitação"
                />
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    disabled={!eventSelected || !message}
                    className="border-0 py-1 px-4 btn-submit"
                  >
                    Enviar
                  </button>
                </div>
              </Form>
            </Events>
          </div> */}
        </div>
      </div>
      <Loading active={loading} text="Enviando..." />
    </Container>
  );
};

export default Support;
